import { getClientSideLoginPageRedirect } from 'Utilities/helpers/getClientSideLoginPageRedirect/getClientSideLoginPageRedirect';
import { getServerSideLoginPageRedirect } from 'Utilities/helpers/getServerSideLoginPageRedirect/getServerSideLoginPageRedirect';
import isClientSideAuth from 'Utilities/helpers/isClientSideAuth';
import { isServerSideAuth } from 'Utilities/helpers/isServerSideAuth/isServerSideAuth';

import type { GetInitialPropsMiddleware } from '../getInitialPropsMiddlewares.types';

export const auth: GetInitialPropsMiddleware = async (context, next) => {
	const { nextContext } = context;

	if (nextContext.isSSR) {
		if (!isServerSideAuth(nextContext)) {
			getServerSideLoginPageRedirect(nextContext);
			return;
		}
	} else if (!isClientSideAuth()) {
		await getClientSideLoginPageRedirect(nextContext);
		return;
	}

	await next();
};
